export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAILED = "LOGIN_USER_FAILED";

export const GET_LOGIN_USERDATA = "GET_LOGIN_USERDATA";
export const GET_LOGIN_USERDATA_SUCCESS = "GET_LOGIN_USERDATA_SUCCESS";
export const GET_LOGIN_USERDATA_FAILED = "GET_LOGIN_USERDATA_FAILED";

export const FETCH_USER_PERMISSIONS = "FETCH_USER_PERMISSIONS";
export const FETCH_USER_PERMISSIONS_SUCCESS = "FETCH_USER_PERMISSIONS_SUCCESS";
export const FETCH_USER_PERMISSIONS_FAILED = "FETCH_USER_PERMISSIONS_FAILED";

export const FETCH_CURRENT_USER_PROFILE = "FETCH_CURRENT_USER_PROFILE";
export const FETCH_CURRENT_USER_PROFILE_SUCCESS =
  "FETCH_CURRENT_USER_PROFILE_SUCCESS";
export const FETCH_CURRENT_USER_PROFILE_FAILED =
  "FETCH_CURRENT_USER_PROFILE_FAILED";

export const AUTHENTICATE_USER = "AUTHENTICATE_USER";

//****** Reset Password   ********//

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILED = "RESET_PASSWORD_FAILED";

//****** Forgot Password   ********//

export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILED = "FORGOT_PASSWORD_FAILED";

//****** OTP VARIFICATION   ********//

export const OTP_VARIFICATION = "OTP_VARIFICATION";
export const OTP_VARIFICATION_SUCCESS = "OTP_VARIFICATION_SUCCESS";
export const OTP_VARIFICATION_FAILED = "OTP_VARIFICATION_FAILED";

//****** SET NEW PASSWORD  ********//

export const SET_NEW_PASSWORD = "SET_NEW_PASSWORD";
export const SET_NEW_PASSWORD_SUCCESS = "SET_NEW_PASSWORD_SUCCESS";
export const SET_NEW_PASSWORD_FAILED = "SET_NEW_PASSWORD_FAILED";

export const HANDLE_PAGE_LOADING = "HANDLE_PAGE_LOADING";

//****** SET OTP  ********//

export const SET_OTP = "SET_OTP";

//****** Verify Token ********//

export const VERIFY_TOKEN = "VERIFY_TOKEN";
export const VERIFY_TOKEN_SUCCESS = "VERIFY_TOKEN_SUCCESS";
export const VERIFY_TOKEN_FAILED = "VERIFY_TOKEN_FAILED";

//****** Generate Token ********//

export const GENERATE_TOKEN = "GENERATE_TOKEN";
export const GENERATE_TOKEN_SUCCESS = "GENERATE_TOKEN_SUCCESS";
export const GENERATE_TOKEN_FAILED = "GENERATE_TOKEN_FAILED";

//****** Logout User ********//

export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const LOGOUT_USER_FAILED = "LOGOUT_USER_FAILED";
